import i18next from 'i18next';

export const validateEmail = (email: string): string => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (email.length === 0) {
    return i18next.t('validation:generic.required');
  }
  if (!emailRegex.exec(email)) {
    return i18next.t('validation:login.invalidEmail');
  }
  return '';
};

export const validateWebsite = (website: string): string => {
  const websiteRegex = /(?:([A-Za-z]+):)?(\/{0,3})[a-zA-Z0-9][a-zA-Z-0-9]*(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-{}]*[\w@?^=%&amp;/~+#-{}])??/;
  if (website.length > 0 && !websiteRegex.exec(website)) {
    return i18next.t('validation:login.invalidWebsite');
  }
  return '';
};

const validateText = (text: string): string => {
  if (text.length === 0) {
    return i18next.t('validation:generic.required');
  }
  if (text.length > 100) {
    return i18next.t('validation:generic.maxLength', { max: 100 });
  }
  return '';
};

export const validateFirstName = validateText;
export const validateLastName = validateText;
export const validateCompany = validateText;
export const validatePhone = validateText;

export const validatePassword = (pass: string): string => {
  if (pass.length === 0) {
    return i18next.t('validation:generic.required');
  }
  if (pass.length < 8) {
    return i18next.t('validation:generic.minLength', { min: 8 });
  }
  if (pass.length > 100) {
    return i18next.t('validation:generic.maxLength', { max: 100 });
  }
  return '';
};

export const validateSelect = (val: string): string => {
  // eslint-disable-next-line eqeqeq
  if (val?.replace(/[ -]/g, '').length === 0 || val == '-1') {
    return i18next.t('validation:generic.required');
  }
  return '';
};
